import React from "react";

const TopikGenerationFirstChat = ({ formData, languageText }) => {
  if (!formData) return null;

  const { level, type, subtype, topic } = formData;

  return (
    <div className="learning-plan-summary">
      <div className="topik-progression">
        <span className="current-level mt-1 px-2 text-800">
          {languageText.levels[level.toLowerCase()]}
        </span>
      </div>

      <div className="plan-details">
        <div className="detail-item">
          <span className="keduall-ai-tag">{languageText.types[type]}</span>
        </div>

        <div className="detail-item">
          <span className="keduall-ai-tag">
            {
              languageText[type][
                subtype.replace(/_(\w)/g, (_, char) => char.toUpperCase())
              ]
            }
          </span>
        </div>
        {topic && (
          <div className="detail-item">
            <span className="keduall-ai-tag">{topic}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(TopikGenerationFirstChat);
